import { FetchRequest, FetchResponse } from '@rails/request.js'

interface Lock {
  created_at: string
  id: string
  review_session_id: string
  submission_id: string
  updated_at: string
}

interface UpdateArgs {
  id: string
}

interface UpdateResponse extends FetchResponse {
  get json(): Promise<Lock | null>
}

export function update({ id }: UpdateArgs): Promise<UpdateResponse> {
  const endpoint = `/api/review_sessions/${id}`

  return new FetchRequest('put', endpoint).perform()
}
